import { SelectItem } from "@components/Common/Select/types"

const selectBoolean: SelectItem[] = [
    { label: 'Sim', value: true },
    { label: 'Não', value: false },
]

export default selectBoolean